import { ICollection } from 'types/collection';
import { IconSet, IconStyleId } from 'types/icons';

type IDesign = ICollection['design'];

export const DEFAULT_ICON_SET: IconSet = 'feather';

const STYLE_ID_TO_SET: Record<IconStyleId, IconSet> = {
  minimal: 'feather',
  outline: 'remix',
  duotone: 'phosphor',
  handdrawn: 'khushmeen'
};

/** null means "keep the per-template artwork", which is not the same as defaulting to feather. */
export const resolveIconSet = (design: IDesign | undefined, isEnabled: boolean): IconSet | null => {
  if (!isEnabled) return null;

  const id = design?.iconSet?.trim().toLowerCase() as IconStyleId | undefined;

  if (!id) return DEFAULT_ICON_SET;

  return STYLE_ID_TO_SET[id] || DEFAULT_ICON_SET;
};

// Icon sets dress the main gallery only; the shop, photobook, portfolio and the gallery's
// secondary pages keep their per-template artwork.
const ICON_SET_PATHS = /^\/(?:selections(?:\/[^/]+)?)?\/?$/;

export const isIconSetPath = (pathname: string): boolean => ICON_SET_PATHS.test(pathname);

// Measured 2026-09-11 over 8 probe slugs: khushmeen's viewBoxes are cropped to the ink and read
// +26.7% against feather; remix and phosphor within 2%. Re-measure if the artwork is replaced.
export const ICON_SET_SCALE: Record<IconSet, number> = {
  feather: 1,
  remix: 1,
  phosphor: 1,
  khushmeen: 0.79
};
